import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FileTextIcon, ClockIcon, BookOpenIcon, WalletIcon, ShieldCheckIcon, CheckIcon, GiftIcon, XIcon, ChevronRightIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  const [showBonusDetails, setShowBonusDetails] = useState(false);
  const handleBuyClick = () => {
    trackAddToCart();
  };
  return <section id="offer-cta" className="px-4 py-20 md:py-28 bg-midnight-900/50" data-id="element-229">
      <div className="max-w-2xl mx-auto" data-id="element-230">
        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="mb-12" data-id="element-231">
          <img src="https://cdn.magicpatterns.com/uploads/4Yazgb7vTHxJ24STkYciEW/The_0_Tax_Rescue_Guide_Product_Image.png" alt="The $0 Tax Rescue Guide shown on laptop, tablet, and phone screens" className="w-full h-auto rounded-lg" data-id="element-232" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="relative" data-id="element-233">
          {/* Ambient glow behind card */}
          <div className="absolute inset-0 -m-4 rounded-2xl pointer-events-none" style={{
          background: 'radial-gradient(ellipse at center, rgba(246,185,59,0.08) 0%, transparent 70%)'
        }} aria-hidden="true" data-id="element-234" />

          <div className="relative bg-midnight-800 border-2 border-rescue-gold/30 rounded-xl p-8 md:p-10 text-center" data-id="element-235">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3" data-id="element-236">
              Get the Full $0 Tax Rescue Guide
            </h2>
            <p className="font-body text-gray-400 mb-8 max-w-lg mx-auto" data-id="element-237">
              Stop the clock, skip the fees, and get your life back for less
              than the cost of a pizza.
            </p>

            {/* CTA Button */}
            <a href="https://www.helpyourselfguides.com/cart/51449100796194:1" target="_blank" rel="noopener noreferrer" role="button" onClick={() => handleBuyClick()} className="inline-block w-full max-w-md bg-rescue-gold text-midnight-950 font-body font-bold text-lg md:text-xl px-8 py-4 rounded-lg transition-all duration-200 hover:bg-amber-400 hover:shadow-lg hover:shadow-rescue-gold/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-rescue-gold focus-visible:ring-offset-2 focus-visible:ring-offset-midnight-800 uppercase tracking-wide mb-8" data-id="element-238">
              Download the Rescue Guide Now
            </a>

            {/* What's included - brief */}
            <ul className="text-left max-w-sm mx-auto space-y-3 mb-6" data-id="element-239">
              <li className="flex items-center gap-3" data-id="element-240">
                <CheckIcon className="w-4 h-4 text-rescue-green flex-shrink-0" aria-hidden="true" data-id="element-241" />
                <span className="font-body text-sm text-gray-300" data-id="element-242">
                  The $0 Tax Rescue Guide (PDF)
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-243">
                <CheckIcon className="w-4 h-4 text-rescue-green flex-shrink-0" aria-hidden="true" data-id="element-244" />
                <span className="font-body text-sm text-gray-300" data-id="element-245">
                  60-Minute Filing Sprint Checklist
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-246">
                <CheckIcon className="w-4 h-4 text-rescue-green flex-shrink-0" aria-hidden="true" data-id="element-247" />
                <span className="font-body text-sm text-gray-300" data-id="element-248">
                  "Plain English" Translation Key
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-249">
                <CheckIcon className="w-4 h-4 text-rescue-green flex-shrink-0" aria-hidden="true" data-id="element-250" />
                <span className="font-body text-sm text-gray-300" data-id="element-251">
                  "I Can't Pay" Protocol
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-252">
                <CheckIcon className="w-4 h-4 text-rescue-green flex-shrink-0" aria-hidden="true" data-id="element-253" />
                <span className="font-body text-sm text-gray-300" data-id="element-254">
                  Audit-Proof Category Map
                </span>
              </li>
            </ul>

            {/* Free Bonuses */}
            <div className="max-w-sm mx-auto mb-10" data-id="element-255">
              <div className="flex items-center gap-2 mb-4" data-id="element-256">
                <div className="flex-1 h-px bg-rescue-gold/20" data-id="element-257" />
                <div className="flex items-center gap-1.5 px-3" data-id="element-258">
                  <GiftIcon className="w-3.5 h-3.5 text-rescue-gold" aria-hidden="true" data-id="element-259" />
                  <span className="font-body text-xs font-bold uppercase tracking-widest text-rescue-gold" data-id="element-260">
                    3 Free Bonuses Included
                  </span>
                </div>
                <div className="flex-1 h-px bg-rescue-gold/20" data-id="element-261" />
              </div>

              <ul className="text-left space-y-3" data-id="element-262">
                <li className="flex items-start gap-3" data-id="element-263">
                  <GiftIcon className="w-4 h-4 text-rescue-gold flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-264" />
                  <div data-id="element-265">
                    <span className="font-body text-sm text-white font-semibold" data-id="element-266">
                      10-Minute Tax Triage Quick-Start
                    </span>
                    <span className="font-body text-xs text-gray-500 ml-2 line-through" data-id="element-267">
                      $9
                    </span>
                    <span className="font-body text-xs text-rescue-green ml-1 font-semibold" data-id="element-268">
                      FREE
                    </span>
                  </div>
                </li>
                <li className="flex items-start gap-3" data-id="element-269">
                  <GiftIcon className="w-4 h-4 text-rescue-gold flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-270" />
                  <div data-id="element-271">
                    <span className="font-body text-sm text-white font-semibold" data-id="element-272">
                      W-2 + 1099 Panic-Proof Category Map
                    </span>
                    <span className="font-body text-xs text-gray-500 ml-2 line-through" data-id="element-273">
                      $9
                    </span>
                    <span className="font-body text-xs text-rescue-green ml-1 font-semibold" data-id="element-274">
                      FREE
                    </span>
                  </div>
                </li>
                <li className="flex items-start gap-3" data-id="element-275">
                  <GiftIcon className="w-4 h-4 text-rescue-gold flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-276" />
                  <div data-id="element-277">
                    <span className="font-body text-sm text-white font-semibold" data-id="element-278">
                      Submit With Confidence — 7-Point Error Shield
                    </span>
                    <span className="font-body text-xs text-gray-500 ml-2 line-through" data-id="element-279">
                      $9
                    </span>
                    <span className="font-body text-xs text-rescue-green ml-1 font-semibold" data-id="element-280">
                      FREE
                    </span>
                  </div>
                </li>
              </ul>

              {/* Read More */}
              <button onClick={() => setShowBonusDetails(true)} className="mt-4 inline-flex items-center gap-1 font-body text-sm font-semibold text-rescue-gold hover:text-amber-400 transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-rescue-gold focus-visible:ring-offset-2 focus-visible:ring-offset-midnight-800 rounded" data-id="element-281">
                Read More
                <ChevronRightIcon className="w-4 h-4" aria-hidden="true" data-id="element-282" />
              </button>
            </div>

            {/* Price */}
            <div className="mb-0" data-id="element-283">
              <div className="flex flex-col items-center gap-1 mb-2" data-id="element-284">
                <div className="flex items-center justify-center gap-3" data-id="element-285">
                  <span className="font-heading text-2xl md:text-3xl font-bold text-gray-500 line-through" data-id="element-286">
                    $46.99
                  </span>
                  <span className="font-body text-sm font-bold uppercase tracking-wide bg-rescue-green/15 text-rescue-green px-3 py-1 rounded-full" data-id="element-287">
                    Save 85%
                  </span>
                </div>
                <span className="font-body text-xs text-gray-500" data-id="element-288">
                  $19.99 guide + $27.00 in free bonuses
                </span>
              </div>
              <span className="font-heading text-6xl md:text-7xl font-bold text-rescue-gold" data-id="element-289">
                $6.99
              </span>
            </div>

            {/* Trust signals */}
            <p className="font-body text-sm text-gray-500 mt-5" data-id="element-290">
              One-time payment. Instant digital access. No hidden upsells.
            </p>
          </div>
        </motion.div>
      </div>

      {/* Bonus Details Modal */}
      <AnimatePresence data-id="element-291">
        {showBonusDetails && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-midnight-950/80 backdrop-blur-sm p-4 md:p-8" onClick={() => setShowBonusDetails(false)} data-id="element-292">
            <motion.div initial={{
          opacity: 0,
          y: 30,
          scale: 0.97
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 20,
          scale: 0.97
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} className="relative w-full max-w-2xl my-8 bg-midnight-800 border border-midnight-700/60 rounded-xl overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-293">
              {/* Modal Header */}
              <div className="sticky top-0 z-10 flex items-center justify-between px-6 py-4 bg-midnight-800 border-b border-midnight-700/60" data-id="element-294">
                <div className="flex items-center gap-2" data-id="element-295">
                  <GiftIcon className="w-5 h-5 text-rescue-gold" aria-hidden="true" data-id="element-296" />
                  <h3 className="font-heading text-lg font-bold text-white" data-id="element-297">
                    Your 3 Free Bonuses
                  </h3>
                </div>
                <button onClick={() => setShowBonusDetails(false)} className="p-2 rounded-lg text-gray-400 hover:text-white hover:bg-midnight-700 transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-rescue-gold" aria-label="Close bonus details" data-id="element-298">
                  <XIcon className="w-5 h-5" data-id="element-299" />
                </button>
              </div>

              {/* Modal Content */}
              <div className="p-6 space-y-8" data-id="element-300">
                {/* BONUS #1 */}
                <div className="rounded-lg border border-midnight-700/60 overflow-hidden" data-id="element-301">
                  <div className="md:flex" data-id="element-302">
                    <div className="md:w-2/5 flex-shrink-0" data-id="element-303">
                      <img src="https://cdn.magicpatterns.com/uploads/sux21DPJvNrYqb9Sk3RzXh/10-Minute-Tax-Triage-Quick-Start_Image.png" alt="10-Minute Tax Triage Quick-Start shown on a tablet screen" className="w-full h-full object-cover" data-id="element-304" />
                    </div>
                    <div className="p-5 md:w-3/5" data-id="element-305">
                      <div className="flex items-center gap-2 mb-3" data-id="element-306">
                        <span className="font-body text-xs font-bold uppercase tracking-widest text-rescue-gold" data-id="element-307">
                          Free Bonus #1
                        </span>
                        <span className="font-body text-xs text-gray-500 line-through" data-id="element-308">
                          $9
                        </span>
                        <span className="font-body text-xs text-rescue-green font-semibold" data-id="element-309">
                          FREE
                        </span>
                      </div>
                      <h4 className="font-heading text-lg font-bold text-white mb-1" data-id="element-310">
                        The 10-Minute Tax Triage Quick-Start
                      </h4>
                      <p className="font-body text-sm text-gray-500 italic mb-3" data-id="element-311">
                        "Start Here Tonight"
                      </p>
                      <p className="font-body text-sm text-gray-400 leading-relaxed mb-3" data-id="element-312">
                        In 10 minutes flat you will know your exact filing path,
                        the only documents you actually need tonight, and the 5
                        red-flag mistakes that cause rejections and refund
                        delays before you make them.
                      </p>
                      <p className="font-body text-sm text-rescue-gold font-semibold" data-id="element-313">
                        This bonus alone will save you 45 minutes of confusion.
                      </p>
                    </div>
                  </div>
                </div>

                {/* BONUS #2 */}
                <div className="rounded-lg border border-midnight-700/60 overflow-hidden" data-id="element-314">
                  <div className="md:flex" data-id="element-315">
                    <div className="md:w-2/5 flex-shrink-0" data-id="element-316">
                      <img src="https://cdn.magicpatterns.com/uploads/oc8yeo7k362FS5gfrfNv12/W2-1099-PanicProof-Category-Map.png" alt="W-2 + 1099 Panic-Proof Category Map shown on a tablet screen" className="w-full h-full object-cover" data-id="element-317" />
                    </div>
                    <div className="p-5 md:w-3/5" data-id="element-318">
                      <div className="flex items-center gap-2 mb-3" data-id="element-319">
                        <span className="font-body text-xs font-bold uppercase tracking-widest text-rescue-gold" data-id="element-320">
                          Free Bonus #2
                        </span>
                        <span className="font-body text-xs text-gray-500 line-through" data-id="element-321">
                          $9
                        </span>
                        <span className="font-body text-xs text-rescue-green font-semibold" data-id="element-322">
                          FREE
                        </span>
                      </div>
                      <h4 className="font-heading text-lg font-bold text-white mb-1" data-id="element-323">
                        The W-2 + 1099 Panic-Proof Category Map
                      </h4>
                      <p className="font-body text-sm text-gray-500 italic mb-3" data-id="element-324">
                        "So You Don't Guess"
                      </p>
                      <p className="font-body text-sm text-gray-400 leading-relaxed mb-3" data-id="element-325">
                        The Panic-Proof Category Map shows you exactly where
                        every dollar of your W-2 and 1099 income goes — using a
                        dead-simple "3 Buckets System" that eliminates the
                        guesswork on every confusing screen.
                      </p>
                      <ul className="space-y-2 mb-3" data-id="element-326">
                        <li className="flex items-start gap-2" data-id="element-327">
                          <CheckIcon className="w-3.5 h-3.5 text-rescue-green flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-328" />
                          <span className="font-body text-xs text-gray-300" data-id="element-329">
                            Know exactly what to enter and where
                          </span>
                        </li>
                        <li className="flex items-start gap-2" data-id="element-330">
                          <CheckIcon className="w-3.5 h-3.5 text-rescue-green flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-331" />
                          <span className="font-body text-xs text-gray-300" data-id="element-332">
                            Claim only the expenses that are safe tonight
                          </span>
                        </li>
                        <li className="flex items-start gap-2" data-id="element-333">
                          <CheckIcon className="w-3.5 h-3.5 text-rescue-green flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-334" />
                          <span className="font-body text-xs text-gray-300" data-id="element-335">
                            Never freeze on the "Schedule C" screen again
                          </span>
                        </li>
                      </ul>
                      <p className="font-body text-sm text-rescue-gold font-semibold" data-id="element-336">
                        If your taxes are "mixed," this bonus is the difference
                        between stuck and filed.
                      </p>
                    </div>
                  </div>
                </div>

                {/* BONUS #3 */}
                <div className="rounded-lg border border-midnight-700/60 overflow-hidden" data-id="element-337">
                  <div className="md:flex" data-id="element-338">
                    <div className="md:w-2/5 flex-shrink-0" data-id="element-339">
                      <img src="https://cdn.magicpatterns.com/uploads/kgx5RgKyzQrKfS9ZxA4t3o/Submit-With-Confidence.png" alt="Submit With Confidence — 7-Point Error Shield book cover" className="w-full h-full object-cover" data-id="element-340" />
                    </div>
                    <div className="p-5 md:w-3/5" data-id="element-341">
                      <div className="flex items-center gap-2 mb-3" data-id="element-342">
                        <span className="font-body text-xs font-bold uppercase tracking-widest text-rescue-gold" data-id="element-343">
                          Free Bonus #3
                        </span>
                        <span className="font-body text-xs text-gray-500 line-through" data-id="element-344">
                          $9
                        </span>
                        <span className="font-body text-xs text-rescue-green font-semibold" data-id="element-345">
                          FREE
                        </span>
                      </div>
                      <h4 className="font-heading text-lg font-bold text-white mb-1" data-id="element-346">
                        Submit With Confidence — The 7-Point Error Shield
                      </h4>
                      <p className="font-body text-sm text-gray-500 italic mb-3" data-id="element-347">
                        "2-Minute Final Review Before You Hit Submit"
                      </p>
                      <p className="font-body text-sm text-gray-400 leading-relaxed mb-3" data-id="element-348">
                        A quick 7-point pre-flight checklist that catches the
                        exact mistakes that cause rejected returns, delayed
                        refunds, and midnight panic — before they happen.
                      </p>
                      <ul className="space-y-1.5 mb-3" data-id="element-349">
                        <li className="flex items-center gap-2" data-id="element-350">
                          <CheckIcon className="w-3.5 h-3.5 text-rescue-green flex-shrink-0" aria-hidden="true" data-id="element-351" />
                          <span className="font-body text-xs text-gray-300" data-id="element-352">
                            Name spellings verified
                          </span>
                        </li>
                        <li className="flex items-center gap-2" data-id="element-353">
                          <CheckIcon className="w-3.5 h-3.5 text-rescue-green flex-shrink-0" aria-hidden="true" data-id="element-354" />
                          <span className="font-body text-xs text-gray-300" data-id="element-355">
                            SSNs verified
                          </span>
                        </li>
                        <li className="flex items-center gap-2" data-id="element-356">
                          <CheckIcon className="w-3.5 h-3.5 text-rescue-green flex-shrink-0" aria-hidden="true" data-id="element-357" />
                          <span className="font-body text-xs text-gray-300" data-id="element-358">
                            Bank routing confirmed
                          </span>
                        </li>
                        <li className="flex items-center gap-2" data-id="element-359">
                          <CheckIcon className="w-3.5 h-3.5 text-rescue-green flex-shrink-0" aria-hidden="true" data-id="element-360" />
                          <span className="font-body text-xs text-gray-300" data-id="element-361">
                            State return included
                          </span>
                        </li>
                        <li className="flex items-center gap-2" data-id="element-362">
                          <CheckIcon className="w-3.5 h-3.5 text-rescue-green flex-shrink-0" aria-hidden="true" data-id="element-363" />
                          <span className="font-body text-xs text-gray-300" data-id="element-364">
                            Confirmation screenshots saved
                          </span>
                        </li>
                      </ul>
                      <p className="font-body text-xs text-gray-400 leading-relaxed" data-id="element-365">
                        <span className="text-gray-300 font-semibold" data-id="element-366">
                          Plus:
                        </span>{' '}
                        A calm "if rejected, fix this first" recovery plan so a
                        rejection code never spirals into a panic attack.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Modal Footer */}
              <div className="sticky bottom-0 px-6 py-4 bg-midnight-800 border-t border-midnight-700/60" data-id="element-367">
                <button onClick={() => setShowBonusDetails(false)} className="w-full bg-rescue-gold/10 border border-rescue-gold/30 text-rescue-gold font-body font-semibold text-sm px-6 py-3 rounded-lg hover:bg-rescue-gold/20 transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-rescue-gold" data-id="element-368">
                  Got It — Back to Checkout
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </section>;
}